/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Запрос с идентификатором файла
 */
export interface UpdateStatusRequest {
  /**
   * Идентификатор файла
   * @format uuid
   */
  id: string;
}

/**
 * Пустой ответ
 */
export type EmptyResponse = object;

/**
 * Привилегия
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  desc?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Сообщение SWIFT для списка
 */
export interface SwiftMessageForList {
  /** @format uuid */
  id?: string;
  toBank?: boolean;
  state?: string;
  number?: string;
  fileName?: string;

  /** @format int64 */
  fileSize?: number;
  mtType?: string;

  /** @format uuid */
  extId?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  sendDate?: string;
  isReady?: boolean;
  errorCode?: string;
  errorDescription?: string;
  permissions?: PermissionResponse[];
}

/**
 * Ответ со списком сообщений SWIFT
 */
export interface SwiftMessageListResponse {
  hasMore?: boolean;

  /** @format int32 */
  size?: number;
  data?: SwiftMessageForList[];
}

/**
 * Сообщение SWIFT для детальной формы
 */
export interface SwiftMessageForDetail {
  /** @format uuid */
  id?: string;
  toBank?: boolean;
  state?: string;
  number?: string;
  fileName?: string;

  /** @format int64 */
  fileSize?: number;
  mtType?: string;

  /** @format uuid */
  extId?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date-time */
  sendDate?: string;
  isReady?: boolean;
  errorCode?: string;
  errorDescription?: string;
  permissions?: PermissionResponse[];
}

/**
 * Документ
 */
export interface Document {
  /** Тип документа */
  type?: DocumentType;

  /** Поля документа */
  fields?: DocumentFields;
}

/**
 * Поля документа
 */
export type DocumentFields = SwiftMessageCcb;

/**
 * Тип документа
 */
export interface DocumentType {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: Document;
}

/**
 * ККБ Сообщения SWIFT
 */
export interface SwiftMessageCcb {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Номер файла-загрузки */
  number?: string;

  /** Имя файла */
  fileName?: string;

  /**
   * Размер файла
   * @format int64
   */
  size?: number;

  /** Внешний идентификатор */
  extId?: string;

  /** Хэш файла вложения */
  hashFile?: string;

  /** ИД клиента в МС */
  clientId?: string;

  /**
   * Дата создания-загрузки по Москве
   * @format date-time
   */
  createDate?: string;
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Данные о действующем сертификате
 */
export interface ClientCertificateResponse {
  /** Серийный номер сертификата */
  serial?: string;

  /** Имя эмитента сертификата (центра сертификации) */
  issuer?: string;

  /** Идентификатор пользователя ДБО ЮЛ, который подписывал документ */
  userId?: string;

  /** Идентификатор клиента ДБО ЮЛ */
  clientId?: string;
}

export interface GetListParams {
  /** @format int32 */
  size: number;

  /** @format int32 */
  position: number;
  toBank?: boolean;

  /** @format date */
  beginDate?: string;

  /** @format date */
  endDate?: string;
  compositeParam?: string;
  stateList?: string[];
}

export interface GetCcbParams {
  /** @format uuid */
  documentId: string;
  documentType: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-swift-messages
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-swift-messages.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Сообщения SWIFT
     * @name Upload
     * @summary Загрузка файла сообщения SWIFT
     * @request POST:/api/swift-messages/v1/external/swift-message/upload
     * @secure
     */
    upload: (data: { file: File }, params: RequestParams = {}) =>
      this.request<string, GenericError>({
        path: `/api/swift-messages/v1/external/swift-message/upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сообщения SWIFT
     * @name UpdateStatus
     * @summary Обновление статуса файла сообщения SWIFT
     * @request POST:/api/swift-messages/v1/external/swift-message/update-status
     * @secure
     */
    updateStatus: (data: UpdateStatusRequest, params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/swift-messages/v1/external/swift-message/update-status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сообщения SWIFT
     * @name GetList
     * @summary Получение списка файлов сообщений SWIFT
     * @request GET:/api/swift-messages/v1/external/swift-message
     * @secure
     */
    getList: (query: GetListParams, params: RequestParams = {}) =>
      this.request<SwiftMessageListResponse, GenericError>({
        path: `/api/swift-messages/v1/external/swift-message`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сообщения SWIFT
     * @name GetDetail
     * @summary Получение деталей файла сообщения SWIFT
     * @request GET:/api/swift-messages/v1/external/swift-message/{id}
     * @secure
     */
    getDetail: (id: string, params: RequestParams = {}) =>
      this.request<SwiftMessageForDetail, GenericError>({
        path: `/api/swift-messages/v1/external/swift-message/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сообщения SWIFT
     * @name Delete
     * @summary Удаление файла сообщения SWIFT
     * @request DELETE:/api/swift-messages/v1/external/swift-message/{id}
     * @secure
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/swift-messages/v1/external/swift-message/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сообщения SWIFT
     * @name Download
     * @summary Скачивание файла сообщения SWIFT
     * @request GET:/api/swift-messages/v1/external/swift-message/{id}/download
     * @secure
     */
    download: (id: string, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/swift-messages/v1/external/swift-message/${id}/download`,
        method: "GET",
        secure: true,
        format: "formData",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграция с МС Подтверждения
     * @name GetCcb
     * @summary Получение ККБ документа
     * @request GET:/api/swift-messages/v1/external/confirmation/order-ccb
     * @secure
     */
    getCcb: (query: GetCcbParams, params: RequestParams = {}) =>
      this.request<OrderCcbResponse, GenericError>({
        path: `/api/swift-messages/v1/external/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграция с МС Подтверждения
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/swift-messages/v1/external/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, GenericError>({
        path: `/api/swift-messages/v1/external/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграция с МС Управление сертификатами
     * @name GetClientActiveCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/swift-messages/v1/external/certificate/client-active-certificate
     * @secure
     */
    getClientActiveCertificate: (params: RequestParams = {}) =>
      this.request<ClientCertificateResponse, GenericError>({
        path: `/api/swift-messages/v1/external/certificate/client-active-certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
